import { computed, inject, Injectable } from '@angular/core';
import { AuthStoreService } from '@features/auth/infrastructure/services/auth-store/auth-store.service';

const COMMON_ROUTES = ['dashboard', 'users', 'approve-users', 'marketplace', 'templates', 'reports', 'farms', 'lots', 'fields',
  'field_actions', 'cows', 'groups', 'livestock', 'actions', 'documents', 'scheduledPlans', 'scheduledInstances'
  , 'analysis', 'profile', 'wallet', 'config'];

@Injectable({ providedIn: 'root' })
export class RolePermissionService {
  #authStore = inject(AuthStoreService);
  #user = this.#authStore.user;
  userRole = computed(() => {
    const role = this.#user()?.role;
    return (role && role in UserRole ? UserRole[role as keyof typeof UserRole] : UserRole.GUEST);
  });
  isAdmin = computed(() => this.userRole() === UserRole.ADMIN);
  isGuest = computed(() => this.userRole() === UserRole.GUEST);
  #rolePermissions: Record<UserRole, string[]> = {
    [UserRole.ADMIN]: [],
    [UserRole.NONE]: [],
    [UserRole.FARMER]: [...COMMON_ROUTES],
    [UserRole.LOGISTIC]: [...COMMON_ROUTES],
    [UserRole.VETERINARIAN]: [...COMMON_ROUTES],
    [UserRole.BUTCHER]: [...COMMON_ROUTES],
    [UserRole.GUEST]: ['dashboard', 'profile'],
  };

  isRoutePermitted(route: string) {
    if (this.isAdmin()) return true;
    const role = this.userRole();
    const permissions = this.#rolePermissions[role] || [];
    return permissions.includes(route);
  }
}


export enum UserRole {
  NONE = 'NONE',
  ADMIN = 'ADMIN',
  GUEST = 'GUEST',
  FARMER = 'FARMER',
  VETERINARIAN = 'VETERINARIAN',
  LOGISTIC = 'LOGISTIC',
  BUTCHER = 'BUTCHER'
}

